import { useState, Suspense, useCallback, useRef, useEffect, useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { AgGridColumn, AgGridReact } from "ag-grid-react";

// import { Pagination } from "@material-ui/lab";
import { CustomPagination } from "../../../shared";
import { Button } from "@material-ui/core";
import { CellValueChangedEvent, ColumnApi, GridApi, GridReadyEvent } from "ag-grid-community";

import { UIContext } from "../../../../contexts";
import { ADMIN_DASHBOARD_HEADER } from "../../../../constants/caption/dashboardHeader";
import { api } from "../../../../utils/api";

import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import getAgGridHeight from "../../../../utils/commonFunctions/getAgGridHeight";
import { ReportType } from "../../../../@types/reportType.types";
import { useEmployerRoute } from "../../../../hooks";
import useRouteParam from "../../../../hooks/useRouteParam";
import ExtractRouteParams from "../../../../utils/commonFunctions/extractRouteParams";
import { LINK } from "../../../../config/config";
import { dateTimeZoneConverter } from "../../../../utils/commonFunctions/date";

interface GeneralReportManagementProps {
	dataReports: any[];
}

const GeneralReportManagement = ({ dataReports }: GeneralReportManagementProps): JSX.Element => {
	// console.log("GeneralReportManagement dataReports: ", dataReports);
	const [agGridAPI, setAgGridAPI] = useState<GridApi | null>(null);
	const [agGridColumnAPI, setAgGridColumnAPI] = useState<ColumnApi | null>(null);
	const agGridRef = useRef<any>(null);
	const [isRowSelected, setIsRowSelected] = useState(false);
	const navigate = useNavigate();
	const isEmployerRoute = useEmployerRoute();
	const queryGroupNumber = useRouteParam("gn");
	const routeParam = ExtractRouteParams(); // This is to extract the route after ?(Question Mark)
	const { setDashboardHeader } = useContext(UIContext);
	const [gridHeight, setGridHeight] = useState("300px");

	// const [reportData, setReportData] = useState<ReportType[]>([
	// 	{
	// 		report_type: "Census Report",
	// 		description: "This report will pull the active employee details along with their dependents.",
	// 		last_generated_on: "",
	// 		last_generated_by: ""
	// 	},
	// 	{
	// 		report_type: "Benefit Changes Report",
	// 		description: "This report will show all the benefits added or ended between a range of dates.",
	// 		last_generated_on: "",
	// 		last_generated_by: ""
	// 	},
	// 	{
	// 		report_type: "Employee Info Changes Report",
	// 		description:
	// 			"This report will get generated for a particular timestamp where it will contain the Status Changes, Personal Changes, Hire, Rehire and Termination.",
	// 		last_generated_on: "",
	// 		last_generated_by: ""
	// 	},
	// 	{
	// 		report_type: "Personal Change Report",
	// 		description: "This report will get generated the personal changes as per the plan selection.",
	// 		last_generated_on: "",
	// 		last_generated_by: ""
	// 	},
	// 	{
	// 		report_type: "Dependent Report",
	// 		description:
	// 			"This report will show all the dependents who is added in given date range and their benefit(s) will also reflect in this report.",
	// 		last_generated_on: "",
	// 		last_generated_by: ""
	// 	},
	// 	{
	// 		report_type: "Location Employees Report",
	// 		description:
	// 			"This Report will generate all the employees of a Particular Location of a Group which is selected or for all locations.",
	// 		last_generated_on: "",
	// 		last_generated_by: ""
	// 	},
	// 	{
	// 		report_type: "Total Deduction Report",
	// 		description: "This Report will get generated with all the employee deduction for all the plans.",
	// 		last_generated_on: "",
	// 		last_generated_by: ""
	// 	},
	// 	// {
	// 	// 	report_type: "Yearly Open Enrollment Report",
	// 	// 	description: "This report will be available if any Yearly Open Enrollment event is active.",
	// 	// 	last_generated_on: "12-14-2022",
	// 	// 	last_generated_by: "Sourish Mukherjee"
	// 	// },
	// 	{
	// 		report_type: "Plan Deduction Report",
	// 		description: "This report will be generated for Deduction as per the deduction code.",
	// 		last_generated_on: "",
	// 		last_generated_by: ""
	// 	},
	// 	{
	// 		report_type: "VEB Deduction Report",
	// 		description: "This report will be generated for VEB Deduction as per the VEB deduction code.",
	// 		last_generated_on: "",
	// 		last_generated_by: ""
	// 	},
	// 	{
	// 		report_type: "Employee Termination Report",
	// 		description:
	// 			"This report will get generated for all the list of terminated employees of the selected group.",
	// 		last_generated_on: "",
	// 		last_generated_by: ""
	// 	},
	// 	// {
	// 	// 	report_type: "Open Enrollment Changes Report",
	// 	// 	description:
	// 	// 		"This report will show all the employees of the open enrollment done of a particular plan with a specific date range.",
	// 	// 	last_generated_on: "",
	// 	// 	last_generated_by: ""
	// 	// },
	// 	{
	// 		report_type: "Dependent More Than Equal To 26 Years Report",
	// 		description: "This report will pull all the dependents with 26 Years and is enrolled in any group plan.",
	// 		last_generated_on: "",
	// 		last_generated_by: ""
	// 	},
	// 	{
	// 		report_type: "WLT Comparison Report",
	// 		description: "This report will get generated by comparing with WLT fields.",
	// 		last_generated_on: "",
	// 		last_generated_by: ""
	// 	},
	// 	{
	// 		report_type: "VEB Waived Benefits Report",
	// 		description:
	// 			"This report will pull all the Members whose active for VEB Benefits in previous year but waived for current year.",
	// 		last_generated_on: "",
	// 		last_generated_by: ""
	// 	},
	// 	{
	// 		report_type: "Active Plan For Employee Report",
	// 		description: "This report will pull all the Active Group Plan(s) with total premium.",
	// 		last_generated_on: "",
	// 		last_generated_by: ""
	// 	},
	// 	{
	// 		report_type: "Active Paycheck Report",
	// 		description: "This report will pull the active employee's paycheck.",
	// 		last_generated_on: "",
	// 		last_generated_by: ""
	// 	},
	// 	{
	// 		report_type: "Active Health Plan And Clinic Card For Member Report",
	// 		description:
	// 			"(For Marketing Email/Message Purpose) This report will pull all the active Health Plan and Clinic Card Member Details (Marketing Email/Message Report).",
	// 		last_generated_on: "",
	// 		last_generated_by: ""
	// 	},
	// 	{
	// 		report_type: "VEB Billing Report",
	// 		description: "This report will pull all the billing details of VEB Plans.",
	// 		last_generated_on: "",
	// 		last_generated_by: ""
	// 	},
	// 	// {
	// 	// 	report_type: "Remittance Report",
	// 	// 	description: "This report will pull all the billing details of VEB Carrier wise.",
	// 	// 	last_generated_on: "",
	// 	// 	last_generated_by: ""
	// 	// },
	// 	// {
	// 	// 	report_type: "Active Core Enrollment(s) for YOE Report",
	// 	// 	description: "This report will pull the active Core Enrollments Details for YOE - 2024.",
	// 	// 	last_generated_on: "",
	// 	// 	last_generated_by: ""
	// 	// },
	// 	// {
	// 	// 	report_type: "Active VEB Enrollment(s) for YOE Report",
	// 	// 	description: "This report will pull the active Core Enrollments Details for YOE - 2024.",
	// 	// 	last_generated_on: "",
	// 	// 	last_generated_by: ""
	// 	// },
	// 	// {
	// 	// 	report_type: "Core Previously Active Currently Waived for YOE Report",
	// 	// 	description:
	// 	// 		"This report will pull the Core Enrollments of Previously Active Currently Waived for YOE -2024.",
	// 	// 	last_generated_on: "",
	// 	// 	last_generated_by: ""
	// 	// },
	// 	// {
	// 	// 	report_type: "VEB Previously Active Currently Waived for YOE Report",
	// 	// 	description:
	// 	// 		"This report will pull the VEB Enrollments of Previously Active Currently Waived for YOE -2024.",
	// 	// 	last_generated_on: "",
	// 	// 	last_generated_by: ""
	// 	// },
	// 	{
	// 		report_type: "Core Weekly Premium Change Report",
	// 		description:
	// 			"This report will pull all the weekly employee of Change in Premium in a Particular Core Plan.",
	// 		last_generated_on: "",
	// 		last_generated_by: ""
	// 	},
	// 	{
	// 		report_type: "Core Monthly Premium Change Report",
	// 		description:
	// 			"This report will pull all the monthly employee of Change in Premium in a Particular Core Plan.",
	// 		last_generated_on: "",
	// 		last_generated_by: ""
	// 	},
	// 	{
	// 		report_type: "VEB Weekly Premium Change Report",
	// 		description:
	// 			"This report will pull all the weekly employee of Change in Premium in a Particular Core Plan.",
	// 		last_generated_on: "",
	// 		last_generated_by: ""
	// 	},
	// 	{
	// 		report_type: "VEB Monthly Premium Change Report",
	// 		description:
	// 			"This report will pull all the monthly employee of Change in Premium in a Particular Core Plan.",
	// 		last_generated_on: "",
	// 		last_generated_by: ""
	// 	},
	// 	{
	// 		report_type: "VEB Employment Terminated, But VEB Plan Remains Active Report",
	// 		description: "Employment has been terminated, but the VEB Plan Remains Active Report.",
	// 		last_generated_on: "",
	// 		last_generated_by: ""
	// 	}
	// ]);

	// const getReports = useCallback(async () => {
	// 	const groupNumberQuery = {
	// 		group_number: 220
	// 	};

	// 	const response = await api.reports.getReportLogs(groupNumberQuery);
	// 	// console.log("Report Logs", response);

	// 	// if (response) {
	// 	// 	for (let i = 0; i < reportData.length; i++) {
	// 	// 		for (let j = 0; j < response.length; j++) {
	// 	// 			if (reportData[i].report_type === response[j].name) {
	// 	// 				reportData[i].last_generated_by =
	// 	// 					response[j].last_generated_first_name + " " + response[j].last_generated_last_name;
	// 	// 				reportData[i].last_generated_on = response[j].last_date;
	// 	// 			}
	// 	// 		}
	// 	// 	}
	// 	// 	setReportData(Object.assign([], { ...reportData }));
	// 	// }

	// 	reportData.forEach((data: any) => {
	// 		response.forEach((res_data: any) => {
	// 			// data which are present in both the response and constants
	// 			if (data.report_type === res_data.name) {
	// 				data.last_generated_by =
	// 					res_data.last_generated_first_name + " " + res_data.last_generated_last_name;
	// 				data.last_generated_on = res_data.last_date;
	// 				setReportData(Object.assign([], reportData, { ...data }));
	// 			}
	// 		});
	// 	});
	// 	// eslint-disable-next-line react-hooks/exhaustive-deps
	// }, []);

	const handleAgGridReady = (params: GridReadyEvent) => {
		// eslint-disable-next-line no-unused-vars
		const { api, columnApi } = params;
		setAgGridAPI(api);
		setAgGridColumnAPI(columnApi);
		const columnIds: any[] = [];
		columnApi?.getAllColumns()?.forEach((column: any) => {
			columnIds.push(column.colId);
		});
		columnApi.autoSizeColumns(columnIds);
	};

	const handleFirstDataRendered = (params: any) => {
		params.api.sizeColumnsToFit();
		params.columnApi.setColumnWidth("action", "100%", true);
	};

	const handleDateCellRenderer = ({ value }: { value: any }) => {
		const date = dateTimeZoneConverter(value as string) as string;
		return <div>{value ? date : "N/A"}</div>;
	};

	const handleGenerateReportClick = useCallback(
		({
			_isEmployerRoute,
			_queryGroupNumber
		}: {
			_isEmployerRoute: boolean | null;
			_queryGroupNumber: number | null;
		}) => {
			if (agGridRef?.current) {
				const focusedCell = agGridRef.current.api.getFocusedCell();
				const row = agGridRef.current.api.getDisplayedRowAtIndex(focusedCell.rowIndex);
				const {
					data: {
						report_route,
						report_name,
						report_type,
						report_description,
						report_form_structure,
						api_route
					}
				} = row;

				let pathname;

				// if (report_type === "Census Report") {
				// 	_isEmployerRoute === true && _queryGroupNumber !== null
				// 		? (pathname = `/employer/report/census?${routeParam}`)
				// 		: (pathname = "/report/census");
				// } else if (report_type === "Location Employees Report") {
				// 	_isEmployerRoute === true && _queryGroupNumber !== null
				// 		? (pathname = `/employer/report/location-employee?${routeParam}`)
				// 		: (pathname = "/report/location-employee");
				// } else if (report_type === "Dependent Report") {
				// 	_isEmployerRoute === true && _queryGroupNumber !== null
				// 		? (pathname = `/employer/report/dependent?${routeParam}`)
				// 		: (pathname = "/report/dependent");
				// } else if (report_type === "Total Deduction Report") {
				// 	_isEmployerRoute === true && _queryGroupNumber !== null
				// 		? (pathname = `/employer/report/total-deduction?${routeParam}`)
				// 		: (pathname = "/report/total-deduction");
				// } else if (report_type === "Plan Deduction Report") {
				// 	_isEmployerRoute === true && _queryGroupNumber !== null
				// 		? (pathname = `/employer/report/plan-deduction?${routeParam}`)
				// 		: (pathname = "/report/plan-deduction");
				// } else if (report_type === "Benefit Changes Report") {
				// 	_isEmployerRoute === true && _queryGroupNumber !== null
				// 		? (pathname = `/employer/report/benefit-changes?${routeParam}`)
				// 		: (pathname = "/report/benefit-changes");
				// } else if (report_type === "Personal Change Report") {
				// 	_isEmployerRoute === true && _queryGroupNumber !== null
				// 		? (pathname = `/employer/report/personal-change?${routeParam}`)
				// 		: (pathname = "/report/personal-change");
				// } else if (report_type === "Employee Termination Report") {
				// 	_isEmployerRoute === true && _queryGroupNumber !== null
				// 		? (pathname = `/employer/report/employee-termination?${routeParam}`)
				// 		: (pathname = "/report/employee-termination");
				// } else if (report_type === "Employee Info Changes Report") {
				// 	_isEmployerRoute === true && _queryGroupNumber !== null
				// 		? (pathname = `/employer/report/employee-info-changes?${routeParam}`)
				// 		: (pathname = "/report/employee-info-changes");
				// } else if (report_type === "VEB Deduction Report") {
				// 	_isEmployerRoute === true && _queryGroupNumber !== null
				// 		? (pathname = `/employer/report/veb-deduction?${routeParam}`)
				// 		: (pathname = "/report/veb-deduction");
				// } else if (report_type === "Open Enrollment Changes Report") {
				// 	_isEmployerRoute === true && _queryGroupNumber !== null
				// 		? (pathname = `/employer/report/open-enrollment-changes?${routeParam}`)
				// 		: (pathname = "/report/open-enrollment-changes");
				// } else if (report_type === "WLT Comparison Report") {
				// 	_isEmployerRoute === true && _queryGroupNumber !== null
				// 		? (pathname = `/employer/report/wlt-compare?${routeParam}`)
				// 		: (pathname = "/report/wlt-compare");
				// } else if (report_type === "VEB Waived Benefits Report") {
				// 	_isEmployerRoute === true && _queryGroupNumber !== null
				// 		? (pathname = `/employer/report/veb-waived-benefits?${routeParam}`)
				// 		: (pathname = "/report/veb-waived-benefits");
				// } else if (report_type === "Active Plan For Employee Report") {
				// 	_isEmployerRoute === true && _queryGroupNumber !== null
				// 		? (pathname = `/employer/report/active-plan-for-employee?${routeParam}`)
				// 		: (pathname = "/report/active-plan-for-employee");
				// } else if (report_type === "Active Paycheck Report") {
				// 	_isEmployerRoute === true && _queryGroupNumber !== null
				// 		? (pathname = `/employer/report/active-paycheck?${routeParam}`)
				// 		: (pathname = "/report/active-paycheck");
				// } else if (report_type === "Active Health Plan And Clinic Card For Member Report") {
				// 	_isEmployerRoute === true && _queryGroupNumber !== null
				// 		? (pathname = `/employer/report/active-health-plan-and-clinic-card-for-member?${routeParam}`)
				// 		: (pathname = "/report/active-health-plan-and-clinic-card-for-member");
				// } else if (report_type === "VEB Billing Report") {
				// 	_isEmployerRoute === true && _queryGroupNumber !== null
				// 		? (pathname = `/employer/report/veb-billing?${routeParam}`)
				// 		: (pathname = "/report/veb-billing");
				// } else if (report_type === "Remittance Report") {
				// 	_isEmployerRoute === true && _queryGroupNumber !== null
				// 		? (pathname = `/employer/report/remittance?${routeParam}`)
				// 		: (pathname = "/report/remittance");
				// } else if (report_type === "Active Core Enrollment(s) for YOE Report") {
				// 	_isEmployerRoute === true && _queryGroupNumber !== null
				// 		? (pathname = `/employer/report/active-core-enrollment-for-yoe?${routeParam}`)
				// 		: (pathname = "/report/active-core-enrollment-for-yoe");
				// } else if (report_type === "Active VEB Enrollment(s) for YOE Report") {
				// 	_isEmployerRoute === true && _queryGroupNumber !== null
				// 		? (pathname = `/employer/report/active-veb-enrollment-for-yoe?${routeParam}`)
				// 		: (pathname = "/report/active-veb-enrollment-for-yoe");
				// } else if (report_type === "Core Previously Active Currently Waived for YOE Report") {
				// 	_isEmployerRoute === true && _queryGroupNumber !== null
				// 		? (pathname = `/employer/report/core-previously-active-currently-waived?${routeParam}`)
				// 		: (pathname = "/report/core-previously-active-currently-waived");
				// } else if (report_type === "VEB Previously Active Currently Waived for YOE Report") {
				// 	_isEmployerRoute === true && _queryGroupNumber !== null
				// 		? (pathname = `/employer/report/veb-previously-active-currently-waived?${routeParam}`)
				// 		: (pathname = "/report/veb-previously-active-currently-waived");
				// } else if (report_type === "Core Weekly Premium Change Report") {
				// 	_isEmployerRoute === true && _queryGroupNumber !== null
				// 		? (pathname = `/employer/report/core-weekly-premium-change-report?${routeParam}`)
				// 		: (pathname = "/report/core-weekly-premium-change-report");
				// } else if (report_type === "Core Monthly Premium Change Report") {
				// 	_isEmployerRoute === true && _queryGroupNumber !== null
				// 		? (pathname = `/employer/report/core-monthly-premium-change-report?${routeParam}`)
				// 		: (pathname = "/report/core-monthly-premium-change-report");
				// } else if (report_type === "VEB Weekly Premium Change Report") {
				// 	_isEmployerRoute === true && _queryGroupNumber !== null
				// 		? (pathname = `/employer/report/veb-weekly-premium-change-report?${routeParam}`)
				// 		: (pathname = "/report/veb-weekly-premium-change-report");
				// } else if (report_type === "VEB Monthly Premium Change Report") {
				// 	_isEmployerRoute === true && _queryGroupNumber !== null
				// 		? (pathname = `/employer/report/veb-monthly-premium-change-report?${routeParam}`)
				// 		: (pathname = "/report/veb-monthly-premium-change-report");
				// } else if (report_type === "VEB Employment Terminated, But VEB Plan Remains Active Report") {
				// 	_isEmployerRoute === true && _queryGroupNumber !== null
				// 		? (pathname = `/employer/report/veb-employment-terminated-report?${routeParam}`)
				// 		: (pathname = "/report/veb-employment-terminated-report");
				// } else if (report_type === "Dependent More Than Equal To 26 Years Report") {
				// 	_isEmployerRoute === true && _queryGroupNumber !== null
				// 		? (pathname = `/employer/data-integrity-report/dependent-more-than-26-years?${routeParam}`)
				// 		: (pathname = "/data-integrity-report/dependent-more-than-26-years");
				// }

				if (_isEmployerRoute === true && _queryGroupNumber !== null) {
					pathname = `/employer${report_route}?${routeParam}`;
				} else {
					pathname = `${report_route}`;
				}
				// console.log("Navigating to: ", pathname);
				// navigate(pathname as string);
				navigate(pathname, {
					state: {
						report_name,
						report_type,
						report_description,
						report_form_structure,
						api_route
					}
				});
			}
		},
		[navigate, routeParam]
	);

	const handleActionButtonRender = ({
		_isEmployerRoute,
		_queryGroupNumber
	}: {
		_isEmployerRoute: boolean | null;
		_queryGroupNumber: number | null;
	}) => {
		return (
			<Button
				className="ag-grid-cell-button"
				variant="outlined"
				onClick={() =>
					handleGenerateReportClick({
						_isEmployerRoute,
						_queryGroupNumber
					})
				}
			>
				Generate Report
			</Button>
		);
	};

	const handleSelectionChanged = useCallback(() => {
		const selectedRow = agGridAPI?.getSelectedRows()[0];
		if (selectedRow) {
			setIsRowSelected(true);
		} else {
			setIsRowSelected(false);
		}
	}, [agGridAPI]);

	const handleCellValueRender = ({ value }: { value: string }) => {
		return <div>{value ? <div>{value}</div> : <div style={{ marginLeft: 15 }}>N/A</div>}</div>;
	};

	// useEffect(() => {
	// 	getReports();
	// }, [getReports]);

	useEffect(() => {
		const _gridHeight = getAgGridHeight(dataReports.length);
		setGridHeight(_gridHeight);
	}, [dataReports.length]);

	// console.log("Report Data -> ", reportData);

	return (
		<div className="group-home-page">
			<div className="group-home-pg-grid-container">
				<div className="ag-theme-alpine" style={{ height: gridHeight, width: "100%" }}>
					<AgGridReact
						ref={agGridRef}
						rowData={dataReports}
						onGridReady={handleAgGridReady}
						onFirstDataRendered={handleFirstDataRendered}
						rowSelection={"Single"}
						animateRows
						defaultColDef={{
							filter: "agTextColumnFilter",
							floatingFilter: true,
							resizable: true
						}}
						onSelectionChanged={handleSelectionChanged}
						frameworkComponents={{
							handleActionButtonRender: handleActionButtonRender,
							handleCellValueRender: handleCellValueRender,
							handleDateCellRenderer: handleDateCellRenderer
							// customFloatingFilter: CustomFloatingFilter,
							// customFilter: CustomFilter,
							// schema: groupsFilterSchema,
							// functionToBePassed: functionToBePassed,
							// setPayloadSchema: setGroupsFilterSchema,
							// setParentSchema: setGroups
						}}
						onCellValueChanged={(params: CellValueChangedEvent) => {
							params.api.refreshCells({
								force: true,
								columns: ["branding"]
							});
						}}
						enableCellChangeFlash={true}
					>
						<AgGridColumn
							field="report_name"
							headerName="Report Name"
							floatingFilterComponentParams={{ suppressFilterButton: true }}
							// cellRenderer="handleCellValueRender"
						></AgGridColumn>
						<AgGridColumn
							field="report_description"
							headerName="Description"
							floatingFilterComponentParams={{ suppressFilterButton: true }}
							// cellRenderer="handleCellValueRender"
						></AgGridColumn>
						<AgGridColumn
							// field="last_generated_by"
							field="report_logs.last_generated_by"
							headerName="Last Generated by"
							floatingFilterComponentParams={{ suppressFilterButton: true }}
							cellRenderer="handleCellValueRender"
						></AgGridColumn>
						<AgGridColumn
							// field="last_generated_on"
							field="report_logs.last_generated_on"
							headerName="Last Generated On"
							floatingFilterComponentParams={{ suppressFilterButton: true }}
							cellRenderer="handleDateCellRenderer"
						></AgGridColumn>
						<AgGridColumn
							field="action"
							headerName="Action"
							cellRenderer="handleActionButtonRender"
							cellRendererParams={{
								_isEmployerRoute: isEmployerRoute,
								_queryGroupNumber: queryGroupNumber
							}}
							filter={false}
						></AgGridColumn>
					</AgGridReact>
				</div>
			</div>
		</div>
	);
};

export default GeneralReportManagement;
